import { Input } from '@/components/ui/input';
import React, { useState } from 'react';

const MessageInput = ({ handleSend, isDisabled }) => {
  const [content, setContent] = useState('');

  const handleInputChange = (e) => {
    setContent(e.target.value);
  };

  const handleSendMessage = () => {
    handleSend(content);
    setContent('');
  };

  return (
    <div className="pt-2 border-t flex items-center gap-2 px-2 pb-2">
      <Input
        value={content}
        onChange={handleInputChange}
        onKeyPress={(e) => e.key === 'Enter' && handleSendMessage()}
        type="text"
        placeholder="Type a message..."
        className="focus:ring-0 focus:ring-offset-0 focus-visible:ring-0 focus-visible:ring-offset-0 focus-visible:outline-none focus:outline-none focus:border-lightPurple placeholder:text-gray-400 border border-gray-300 group-hover:border-lightPurple"
        disabled={isDisabled}
        aria-label="Message input"
      />
      <button
        onClick={handleSendMessage}
        disabled={!content.trim() || isDisabled}
        className="text-blue-600 font-semibold hover:underline disabled:opacity-50 disabled:cursor-not-allowed"
        aria-label="Send message"
      >
        Send
      </button>
    </div>
  );
};

export default MessageInput;
